<template>
  <div class="bk-blokkli-item-options-number">
    <button :disabled="numeric <= min" @click.stop.prevent="decrement">
      <Icon name="minus" />
    </button>
    <input
      v-model="text"
      type="number"
      :min="min"
      :max="max"
      :style="{
  width: width + 'px'
}"
    />

    <button :disabled="numeric >= max" @click.stop.prevent="increment">
      <Icon name="plus" />
    </button>
  </div>
</template>

<script setup>
import { computed } from "#imports";
import { Icon } from "#blokkli/components";
const props = defineProps({
  label: { type: String, required: true },
  modelValue: { type: String, required: false, default: "0" },
  min: { type: Number, required: true },
  max: { type: Number, required: true },
  type: { type: String, required: false, default: "text" }
});
const width = computed(() => props.max.toString().length * 30);
const emit = defineEmits(["update:modelValue"]);
const text = computed({
  get() {
    return props.modelValue;
  },
  set(v) {
    emit("update:modelValue", (v === void 0 ? "" : v).toString());
  }
});
const numeric = computed(() => {
  if (props.modelValue === void 0) {
    return 0;
  }
  const v = Number.parseInt(props.modelValue);
  if (Number.isNaN(v)) {
    return 0;
  }
  return v;
});
function increment() {
  text.value = (numeric.value + 1).toString();
}
function decrement() {
  text.value = (numeric.value - 1).toString();
}
</script>

<script>
export default {
  name: "OptionsFormNumber"
};
</script>
